// 
// const content(账号内容) 
const content = () => import('../views/content')
const pageBasic = () => import('../views/content/pageBasic')
const pageSecure = () => import('../views/content/pageSecure')
const pageAuthentication = () => import('../views/content/pageAuthentication')
// const pageAuthority = () => import('../views/content/pageAuthority')
const pageAccount = () => import('../views/content/pageAccount')
// 功能function
const functions = () => import('../views/function')
const pageDebut = () => import('../views/function/pageDebut') //
const pagePlatform = () => import('../views/function/pagePlatform') //
const pageClouds = () => import('../views/function/pageClouds') //
const pagePlatformTow = () => import('../views/function/pagePlatformTow') //
// 直播推荐管理
const LiveRecommendation= () => import('../views/LiveRecommendation')
// 精品直播推荐
const Boutique = () => import('../views/Boutique')
// 权限管理
const Authority = () => import('../views/Authority')
const AuthorityOrdinary = () => import('../views/Authority/ordinary') //人员管理
const AuthorityMember = () => import('../views/Authority/member') //会员管理
const AuthoritySuper = () => import('../views/Authority/super') //超会管理
const AuthorityPersonnel = () => import('../views/Authority/personnel') //店长专属

// 直播推荐审核
const examine = () => import('../views/examine')


const dynamicRouter = [
  {
    path: '/content',
    component: content,
    name: 'content',
    meta:{
      name:'content',
      label:'账号中心'
    },
    children:[
      {
        path: '/pageBasic',
        component: pageBasic,
        name: 'pageBasic',
        meta: {
            name: 'pageBasic',
            label:'基本信息',
            icon:'iconfont icon-wodexinxi_jibenxinxi'
            // icon:
            // icon:require('../image/router-icon/切图/1@3x.png')
        },
      },
      {
        path: '/pageSecure',
        component: pageSecure,
        name: 'pageSecure',
        meta: {
            name: 'pageSecure',
            label:'安全设置',
            icon:'iconfont icon-anquan'
        },
      },
      {
        path: '/pageAuthentication',
        component: pageAuthentication,
        name: 'pageAuthentication',
        meta: {
            name: 'pageAuthentication',
            label:'实名认证',
            // icon:
            icon:'iconfont icon-shiming'
        },
      },
      
      // {
      //   path: '/pageAuthority',
      //   component: pageAuthority,
      //   name: 'pageAuthority',
      //   meta: {
      //       name: 'pageAuthority',
      //       label:'权限管理',
      //       icon:'iconfont icon-quanxianpeizhi'
      //       // icon:
      //   },
      // },
      {
        path: '/pageAccount',
        component: pageAccount,
        name: 'pageAccount',
        meta: {
            name: 'pageAccount',
            label:'账户管理',
            icon:'iconfont icon-zhanghuyue'
            // icon:
        },
      },
    ]
  },
  {
    path: '/functions',
    component: functions,
    name: 'functions',
    hidden: true,
    meta:{
      name:'functions',
      label:'功能中心'
    },
    children:[
      {
        path: '/pagePlatform',
        component: pagePlatform,
        name: 'pagePlatform',
        meta: {
            name: 'pagePlatform',
            label:'功能中心',
            icon:'iconfont icon-anquan',
            hidden: true,
            // icon:
        },
      },
      {
        path: '/pageDebut',
        component: pageDebut,
        name: 'pageDebut',
        meta: {
            name: 'pageDebut',
            label:'开播设置',
            icon:'iconfont icon-wodexinxi_jibenxinxi',
            hidden: true,
            // icon:
        },
      },
     
      {
        path: '/pageClouds',
        component: pageClouds,
        name: 'pageClouds',
        meta: {
            name: 'pageClouds',
            label:'云端录制',
            icon:'iconfont icon-cloud-link',
            hidden: true,
            // icon:
        },
      },
      {
        path: '/pagePlatformTow',
        component: pagePlatformTow,
        name: 'pagePlatformTow',
        meta: {
            name: 'pagePlatformTow',
            label:'多平台直播',
            icon:'iconfont icon-anquan',
            hidden: true,
        // icon:
        },
      },
    ]
  },
  {
    path: '/LiveRecommendation',
    component: LiveRecommendation,
    name: 'LiveRecommendation',
    meta:{
      name:'LiveRecommendation',
      label:'直播推荐'
    }
  },
  {
    path: '/Boutique',
    component: Boutique,
    name: 'Boutique',
    meta:{
      name:'Boutique',
      label:'精品直播推荐'
    }
  },
  {
    path: '/examine',
    component: examine,
    name: 'examine',
    meta:{
      name:'examine',
      label:'直播推荐审核'
    }
  },
  {
    path: '/Authority',
    component: Authority,
    name: 'Authority',
    meta:{
      name:'Authority',
      label:'权限管理'
    },
    children:[
      {
        path: '/AuthorityOrdinary',
        component: AuthorityOrdinary,
        name: 'AuthorityOrdinary',
        meta: {
            name: 'AuthorityOrdinary',
            label:'人员管理',
            icon:'iconfont icon-wodexinxi_jibenxinxi'
            // icon:
            // icon:require('../image/router-icon/切图/1@3x.png')
        },
      },
      {
        path: '/AuthorityMember',
        component: AuthorityMember,
        name: 'AuthorityMember',
        meta: {
            name: 'AuthorityMember',
            label:'会员管理',
            icon:'iconfont icon-wodexinxi_jibenxinxi'
        },
      },
      {
        path: '/AuthoritySuper',
        component: AuthoritySuper,
        name: 'AuthoritySuper',
        meta: {
            name: 'AuthoritySuper',
            label:'超会管理',
            icon:'iconfont icon-wodexinxi_jibenxinxi'
        },
      },
      {
        path: '/AuthorityPersonnel',
        component: AuthorityPersonnel,
        name: 'AuthorityPersonnel',
        meta: {
            name: 'AuthorityPersonnel',
            label:'更改默认权限',
            icon:'iconfont icon-wodexinxi_jibenxinxi'
        },
      },
    ]
  }
 
]
export default dynamicRouter